import { createRouter, createWebHistory } from 'vue-router';

import DashboardPage from '@/components/DashboardPage.vue';
import FunctionBoard from '@/components/FunctionBoard.vue';
import clientRouter from '@/router/client';
import eventRouter from '@/router/event';
import launchRouter from '@/router/launch';
import learningRouter from '@/router/learning';
import participationRouter from '@/router/participation';
import personalRouter from '@/router/personal';
import privateRouter from '@/router/private';
import publicRouter from '@/router/public';
import Logger from '@/utils/logger';

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_PATH),
  routes: [
    // public pages
    ...publicRouter.routes,

    // private entrance
    {
      path: '/:catchAll(.*)',
      redirect: '/dashboard',
    },

    // Top level private pages
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DashboardPage,
    },
    ...participationRouter.routes,
    ...launchRouter.routes,

    // Function pages
    {
      // This path will not appear in url
      // FunctionBoard is a logical container of function pages
      path: '/func',
      component: FunctionBoard,
      children: [...learningRouter.routes, ...clientRouter.routes, ...personalRouter.routes, ...eventRouter.routes],
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  Logger.debug('---------------------');
  Logger.debug(`Request: ${to.path}`);

  // router.app.pageLoading = true;

  try {
    await publicRouter.guard(to, from);
    await privateRouter.guard(to, from);
    await participationRouter.guard(to, from);
    await learningRouter.guard(to, from);
    await launchRouter.guard(to, from);
    await personalRouter.guard(to, from);
    await clientRouter.guard(to, from);
    await eventRouter.guard(to, from);
  } catch (err) {
    // Need to login
    if (err.message === '$KickOut') {
      // router.app.pageLoading = false;
      return next('/login');
    }

    // Nedd to login with a backward path
    if (err.message === '$LoginBack') {
      return next({
        name: 'login',
        query: { backward: to.path },
      });
    }

    // Stay at the original page
    if (err.message === '$Reject') {
      // router.app.pageLoading = false;
      return next(from.path || '/');
    }

    // Route forward
    if (err.message) {
      return next(err.message);
    }

    // Regular access
    return next();
  }

  // Global function pages:
  // dashboard | function
  Logger.debug(`Access: ${to.path}`);
  return next();
});

router.afterEach(() => {
  // router.app.pageLoading = false;
});

export default router;
